export const CONTACTS = {
    COMPANY_SECTION: "company-section",
    SEARCH_CONTACTS: "search-contacts",
    ADD_CONTACT_BTN: "add-contact-btn",
    NEW_COMPANY_BTN: "new-company-btn",
    NEW_BUYER_BTN: "new-buyer-btn",
    SAVE_BTN: "save-btn",
    CANCEL_BTN: "cancel-btn",
    SELECT_COMPANY: "select-company-dropdown",
    COMPANY_NAME_LINK: "company-name-link",
    COMPANY_WEBSITE_LINK: "company-website-link",
    BUYER_NAME_LINK: "buyer-name-link",
    COMPANY_NAME_INPUT: "name-input",
    PHONE_INPUT: "phone-input",
    BUYER_NAME_INPUT: "buyer-name-input",
    BUYER_EMAIL_INPUT: "email-input",
    EDIT_COMPANY_BTN: "edit-company-btn",
    EDIT_BUYER_BTN: "edit-buyer-btn",
    EDIT_BTN: "edit-btn",
    ACCOUNT_NAME: "account-name",
    MODAL: {
        WEBSITE: "website-input",
        TITLE: "title-input",
        BUYER_ENTRY_CONTAINER: "buyer-entry-container",
        ADD_BUYER_ENTRY: "add-buyer-btn",
        REMOVE_BUYER_ENTRY: "remove-buyer-entry",
    },
    ADDRESS_MODAL: {
        DESCRIPTION: "description-input",
        ADDRESS_LINE_1: "address-line-1-input",
    },
    DELETE_BTN: "delete-btn",
    DELETE_BUYER: "delete-buyer",
    DELETE_COMPANY: "delete-company",

    // COMPANY DETAILS PAGE ELEMENTS
    BUYERS_CONTAINER: "buyers-container",
    BUYER_CARD: "buyer-card",
    ADD_BUYER_BTN: "add-buyer-btn",
    ADDRESSES_CONTAINER: "billing--shipping-addresses-container",
    EDIT_COMPANY_MODAL: {
        WHOLESALE_CURRENCIES_CONTROL: "currencies-control",
        MSRP_CURRENCIES_CONTROL: "msrp-currencies-control",
    },
    COMPANY_INFO: {
        BYPASS: "allow_bypass_inventory",
        ACCESS_CONTROL: "access_control",
        LEGAL_FILE: "order-confirmation-legal-file",
    },
    ADD_CC_FORM: "add-new-cc-form",
    SNACKBAR_MESSAGE: "snackbar-message",
    SORT_BTN: "sort-btn",
    SORT_CREATED_NEWEST: "sort-createdondesc",
    SORT_CREATED_OLDEST: "sort-createdonasc",
    SORT_NAME_A_Z: "sort-nameasc",
    SORT_NAME_Z_A: "sort-namedesc",
};
